export default "__VITE_ASSET__27fb11f6__"